import React from 'react';
export function Footer() {
  return <footer className="bg-forest text-sage py-8 px-6 text-center border-t border-white/10" data-id="element-27">
      <div className="max-w-4xl mx-auto" data-id="element-28">
        <p className="font-serif font-bold text-xl mb-2 text-white" data-id="element-29">
          Método Freezer-Fit
        </p>
        <p className="text-sm opacity-70" data-id="element-30">
          © {new Date().getFullYear()} Todos los derechos reservados.
        </p>
        <p className="text-xs opacity-50 mt-4 max-w-2xl mx-auto" data-id="element-31">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}